var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper--fluid",attrs:{"id":"bejelentkezes"}},[_c('section',{staticClass:"grid"},[_c('login-cards',{attrs:{"pull-up":true}})],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e883ed0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 907
// module chunks = 93